// components/admin/AdminLayout.jsx
// Shell that wires sidebar + topbar + all admin pages together
// Pages: Overview (own file) + Paid/Locations/Devices/Referrals/Settings (AdminPages.jsx)

import { useState, useCallback, useEffect } from 'react';
import { AdminSidebar, AdminMobileSidebar } from './AdminSidebar.jsx';
import AdminTopbar    from './AdminTopbar.jsx';
import AdminOverview  from './AdminOverview.jsx';
import AdminUsers   from './AdminUsers.jsx';
import AdminRevenue from './AdminRevenue.jsx';
import AdminUsage    from './AdminUsage.jsx';
import AdminSessions from './AdminSessions.jsx';
import AdminHealth   from './AdminHealth.jsx';
import AdminConfig   from './AdminConfig.jsx';
import AdminReports  from './AdminReports.jsx';
import AdminFeedbackPage from './AdminFeedbackPage.jsx';
import EmailBlast        from './EmailBlast.jsx';
import AdminFeatureConfig from './AdminFeatureConfig.jsx';
import { api } from '../../utils/api.js';
import ToastContainer from '../ToastContainer.jsx';
import {
  AdminLocations,
  AdminDevices,
  AdminReferrals,
  AdminSettings,
} from './AdminPages.jsx';

const PAGES = {
  overview:  AdminOverview,
  paid:      AdminUsers,
  revenue:   AdminRevenue,
  usage:     AdminUsage,
  sessions:  AdminSessions,
  health:    AdminHealth,
  config:    AdminConfig,
  reports:   AdminReports,
  locations: AdminLocations,
  devices:   AdminDevices,
  referrals: AdminReferrals,
  settings:  AdminSettings,
  feedback:      AdminFeedbackPage,
  emailblast:    EmailBlast,
  featureconfig: AdminFeatureConfig,
};

export default function AdminLayout({ user, onLogout, page, onSetPage }) {
  const setPage = useCallback((key) => onSetPage(key), [onSetPage]);
  const [mobOpen, setMobOpen] = useState(false);
  const [feedbackBadge, setFeedbackBadge] = useState(0);

  const openMob  = useCallback(() => setMobOpen(true),  []);
  const closeMob = useCallback(() => setMobOpen(false), []);

  // Fetch unread (status=new) feedback count for sidebar badge
  useEffect(() => {
    api('/feedback?status=new&limit=500')
      .then(data => setFeedbackBadge(data?.total ?? 0))
      .catch(() => {});
  }, [page]); // re-check on every page nav so badge stays fresh

  const badges = { feedback: feedbackBadge };

  const PageComponent = PAGES[page] || AdminOverview;

  return (
    <div className="app-root">
      <AdminSidebar
        page={page} setPage={setPage}
        badges={badges} onLogout={onLogout} user={user}
      />
      <AdminMobileSidebar
        page={page} setPage={setPage}
        badges={badges} open={mobOpen} onClose={closeMob}
        onLogout={onLogout} user={user}
      />
      <div className="main-col">
        <AdminTopbar page={page} onHamburger={openMob}/>
        <div className="page-scroll">
          <PageComponent user={user}/>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}